import type { ReactNode } from 'react';
import type { PlannerHost } from '../model/host';
import { createContext, useContext } from 'react';

const PlannerHostContext = createContext<PlannerHost | null>(null);

export const PlannerHostProvider = ({
  host,
  children,
}: {
  host: PlannerHost;
  children: ReactNode;
}) => (
  <PlannerHostContext.Provider value={host}>
    {children}
  </PlannerHostContext.Provider>
);

export const usePlannerHost = (): PlannerHost => {
  const host = useContext(PlannerHostContext);
  if (!host) {
    throw new Error('AdvisorPlannerWorkspace requires PlannerHostProvider');
  }
  return host;
};

/**
 * The host when there is one, else `null`. For components that only read an
 * optional CAPABILITY (e.g. `showAvgRoomNight`) and stay perfectly usable
 * without a host — a missing provider then means "capability off", not a bug,
 * so they must not take the whole subtree down the way `usePlannerHost` does.
 */
export const useOptionalPlannerHost = (): PlannerHost | null =>
  useContext(PlannerHostContext);
